/**
 * Barras horizontais ranqueadas — o gráfico que 90% das perguntas desta casa pedem.
 *
 * «Quanto cada grupo econômico representa», «quem são os maiores devedores», «quantos títulos por
 * situação»: todas são a mesma forma. Horizontal e não vertical porque o rótulo é um nome de
 * empresa, e nome de empresa não cabe deitado num eixo x.
 *
 * O número vai no DOM, ao lado da barra, SEMPRE. Não há tooltip: numa ferramenta de investigação,
 * um dado que só aparece ao passar o mouse não pode ser copiado, não é lido por leitor de tela e
 * não existe numa captura de tela.
 */
import { Link } from 'react-router-dom';
import { COR_NEUTRA, corDaSerie, largura } from './escalas';

export type ItemBarra = {
  rotulo: string;
  valor: number;
  /** O texto que aparece ao lado da barra. Sem isto, o valor cru — formatar é de quem chama, que
   *  sabe se é dinheiro, porcentagem ou contagem. */
  texto?: string;
  /** Torna o rótulo um link para a ficha. É o que faz um gráfico virar navegação. */
  href?: string;
  /** Cinza para o que não se agrupa; senão, a cor da série. */
  neutro?: boolean;
};

export function Barras({
  itens,
  maximo,
  titulo,
  vazio = 'Sem dados.',
}: {
  itens: ItemBarra[];
  /** Base da largura. Omitido, usa o maior da lista — proporcional ao maior, não ao total. */
  maximo?: number;
  titulo?: string;
  vazio?: string;
}) {
  if (!itens.length) return <p className="tipo-corpo-pequeno text-text-tertiary">{vazio}</p>;
  const maior = maximo ?? Math.max(...itens.map((i) => i.valor), 0);

  return (
    <div className="flex flex-col gap-1.5">
      {titulo && <p className="tipo-rotulo text-text-tertiary">{titulo}</p>}
      {/* Uma lista, e não um <canvas>: o desenho é HTML, então é selecionável, copiável e
          imprimível — e degrada sozinho quando a tela encolhe. */}
      <ul className="flex flex-col gap-1.5">
        {itens.map((item, i) => (
          <li key={`${item.rotulo}-${i}`} className="flex flex-col gap-0.5">
            <div className="flex items-baseline justify-between gap-3">
              <span className="tipo-corpo-pequeno min-w-0 truncate text-text">
                {item.href ? (
                  <Link to={item.href} className="text-accent hover:underline">
                    {item.rotulo}
                  </Link>
                ) : (
                  item.rotulo
                )}
              </span>
              <span className="tipo-dado shrink-0 text-text-secondary">
                {item.texto ?? item.valor.toLocaleString('pt-BR')}
              </span>
            </div>
            <div className="h-1.5 w-full rounded-full bg-surface-3">
              <div
                className="h-1.5 rounded-full"
                style={{
                  width: largura(item.valor, maior),
                  background: item.neutro ? COR_NEUTRA : corDaSerie(i),
                }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
